// ตรงกับ EnumRelationship ฝั่ง flex2-api-nest และ ENUM_RELATIONSHIP ฝั่ง flex2-app-react
export enum EnumRelationship {
  Father = "father",
  Mother = "mother",
  Child = "child",
  Spouse = "spouse",
  LifePartner = "life_partner",
}
